const safeStorageGet = (key) => {
  try {
    return localStorage?.getItem(key) || null;
  } catch {
    return null;
  }
};

const safeStorageSet = (key, value) => {
  try {
    localStorage?.setItem(key, value);
  } catch {
    // Silently fail if storage is not available
  }
};

const safeStorageRemove = (key) => {
  try {
    localStorage?.removeItem(key);
  } catch {
    // Silently fail if storage is not available
  }
};

export const clearAllRegulatoryConsentData = () => {
  try {
    const keys = Object.keys(localStorage || {});
    keys.forEach((key) => {
      if (key.startsWith('regulatoryConsent:')) {
        safeStorageRemove(key);
      }
    });
  } catch {
    // Silently fail if storage is not available
  }
};

export { safeStorageGet, safeStorageSet, safeStorageRemove };
